export default __webpack_public_path__ + "static/media/Pinecone.6e0f3f9f.svg";